// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FilterLanguages_wrap__2ikyU"};